// removed by extract-text-webpack-plugin
module.exports = {"togglebox":"ToggleBox_togglebox__2jCG","buttonLeftAndRight":"ToggleBox_buttonLeftAndRight__2NE6","bounceLeft":"ToggleBox_bounceLeft__9-Ot","buttonLeft":"ToggleBox_buttonLeft___n3w","bounceRight":"ToggleBox_bounceRight__1xrs","buttonRight":"ToggleBox_buttonRight__23KS","toggles":"ToggleBox_toggles__XoYG","toggled":"ToggleBox_toggled__e6s_","toggle-icon":"ToggleBox_toggle-icon__2FqS","loading":"ToggleBox_loading__22k5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Map/ToggleBox/ToggleBox.scss
// module id = 521
// module chunks = 0